import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {GoogleAnalyticsEventModel} from "../../../third-party-services/analytics/google-analytics/google-analytics-event-model";
import {WEBSITE_MODULE} from "../website-module.consts";

export class WebsiteModuleUsPopupClickEvent extends ClickEvent {
  clickType;

  constructor(params) {
    super('click', 'pop-up', 'change-country');

    this.clickType = params.clickType;
  }

  get properties() {
    const properties = super.properties;

    properties.clickType = this.clickType;

    return properties;
  }

  get googleAnalyticsEvent(): null {
    const eventName = WEBSITE_MODULE.GOOGLE_ANALYTICS.EVENTS.click;

    return new GoogleAnalyticsEventModel(eventName, {
      action: this.clickType,
    })
  }
}
